import request, { download } from "@/utils/request";
import axios from "axios";

// 获取发票大类
export function getBasDict() {
  return axios.get("https://static.rhkj.com/renhe_fe/other/invoiceTool/json/baseDict.json");
}

// 获取发票印章
export function getTSMList() {
  return axios.get("https://static.rhkj.com/renhe_fe/other/invoiceTool/json/tsmList.json");
}

// 获取发票数据
export function getInvlist() {
  return axios.get("https://static.rhkj.com/renhe_fe/other/invoiceTool/json/invList.json");
}

// 获取已保存版本
export function getTicketNoteList(data = {}) {
  return request({
    url: `/system/ticketNoteConfig/getTicketNoteList`,
    method: "post",
    headers: { repeatSubmit: false },
    // showLoading: true,
    data,
  });
}

// 票据新增或修改
export function saveOrUpdateTicketNote(data = {}) {
  return request({
    url: `/system/ticketNoteConfig/saveOrUpdateTicketNote`,
    method: "post",
    headers: { repeatSubmit: false },
    showLoading: true,
    data,
  });
}

// 票据删除
export function deleteTickNote(id) {
  return request({
    url: `/system/ticketNoteConfig/deleteTickNote?id=${id}`,
    method: "delete",
    headers: { repeatSubmit: false },
    showLoading: true,
  });
}
